import { mapActions } from 'vuex';
import CommentAdd from '@/components/comment-block/comment-add/index.vue';
import { COMMENT_TYPE, countComments } from '@/helpers';
import { pluralizate } from '@/helpers/variables';
import { cloneDeep } from 'lodash';
import CommentCard from '@/components/comment-block/comment-card/index.vue';

export default {
  name: 'CommentsBlock',
  components: {
    CommentCard,
    CommentAdd
  },
  props: {
    data: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ''
    },
    id: {
      type: [Number, String, null],
      default: null
    },
    type: {
      type: [String, null],
      required: true
    },
    isCanAddGeneral: {
      type: Boolean,
      default: true
    },
    isCanAddUser: {
      type: Boolean,
      default: true
    }
  },
  emits: ['comment-counter'],
  data() {
    return {
      COMMENT_TYPE,
      commentsCount: 0,
      comments: []
    };
  },
  created() {
    this.commentsCount = countComments(this.data, this.type);
    this.comments = cloneDeep(this.data);
  },
  mounted() {},
  watch: {},
  computed: {
    commentsPluralizate() {
      return pluralizate(
        this.commentsCount ? this.commentsCount : 0,
        'коментар',
        'коментарі',
        'коментарів'
      );
    }
  },

  methods: {
    ...mapActions({}),
    onUpdateData(data) {
      if (data[this.type] && data[this.type].data.length) {
        this.commentsCount = countComments(data[this.type].data, this.type);
        this.comments = cloneDeep(data[this.type].data);
        this.$emit('comment-counter', true);
      }
    },
    onUpdateCounter() {
      this.commentsCount++;
      this.$emit('comment-counter', true);
    }
  }
};
